import { render, staticRenderFns } from "./Jmxx.vue?vue&type=template&id=b2195bfc&scoped=true&"
import script from "./Jmxx.vue?vue&type=script&lang=js&"
export * from "./Jmxx.vue?vue&type=script&lang=js&"
import style0 from "./Jmxx.vue?vue&type=style&index=0&id=b2195bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2195bfc",
  null
  
)

export default component.exports